<template>
  <div class="hello">
    <h2>Eventos</h2>
    <div class="event-container">
      <div v-if="isLoading">
        <div v-for="n in 3" :key="n" class="event-item skeleton">
          <div class="img skeleton-box"></div>
          <div class="desc">
            <div class="skeleton-line title"></div>
            <div class="skeleton-line small"></div>
            <div class="skeleton-line small"></div>
          </div>
        </div>
      </div>

      <div v-else>
        <div
          class="event-item"
          v-for="(event, key) in getEvents"
          :key="key"
          @click="openClickedEvent(event)"
          :class="{ disabled: event.open === 'N' }"
        >
          <div class="img">
            <img :src="event.appImage" :alt="event.name" />
          </div>
          <div class="desc">
            <h3 v-text="event.name"></h3>
            <span v-if="event.eventDate" v-text="event.eventDate"></span>
            <span v-else v-text="`${event.startDate} - ${event.endDate}`"></span>
            <span v-text="event.description"></span>
          </div>
        </div>
        <div v-if="!getEvents?.length" class="emptyEvent">
          <fa :icon="['fas', 'calendar-xmark']" size="2x" style="font-size: 60px; color: #999; margin-bottom: 10px"></fa>
          <span v-text="getEventsMessage || 'Não há nenhum evento próximo da data'"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/assets/libs/util'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EventList',
  data () {
    return {}
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getEvents', 'getEventsMessage'])
  },
  methods: {
    ...mapActions(['updateSelectedEvent']),
    openClickedEvent (ev) {
      if (ev.open === 'N') {
        Util.showErrorNotification('Cardápio não disponível para compra antecipada.')
        return false
      }
      this.updateSelectedEvent(ev)
      this.$router.push('/event')
    }
  }
}
</script>

<style scoped lang="less">
.event-container {
  position: relative;
  display: block;
  .event-item {
    position: relative;
    display: grid;
    grid-template-columns: 100px calc(100% - 120px);
    grid-column-gap: 20px;
    margin: 20px 0;

    .img {
      position: relative;
      overflow: hidden;
      border-radius: 8px;

      img {
        width: 100%;
        height: 72px;
        display: block;
        border-radius: 8px;
        object-fit: cover;
      }
    }

    .desc {
      h3 {
        margin: 0 0 5px 0;
        font-size: 16px;
      }
      span {
        font-size: 14px;
        display: block;
        margin-bottom: 5px;
        opacity: 0.6;
      }
    }

    &.disabled {
      filter: grayscale(1);
    }

    &.skeleton {
      pointer-events: none;
    }
  }

  .emptyEvent {
    text-align: center;
    padding: 30px 0;
    color: #666;
    background-color: #f9f9f9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;

    p {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
    }
  }
}

/* Skeleton animation */
.skeleton-box,
.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
  border-radius: 4px;
}

.skeleton-box {
  width: 100px;
  height: 80px;
}

.skeleton-line {
  height: 12px;
  margin-bottom: 8px;
}

.skeleton-line.title {
  width: 70%;
  height: 16px;
}

.skeleton-line.small {
  width: 50%;
}

@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}
</style>
